/** student/progress — API. */
import { http } from '../../_shared/http';
import type { StudentProgress } from './types';

export const studentProgressApi = {
  fetchMine: () => http.get<StudentProgress>('/student-progress/my-progress'),
};
